<div class="dialog-close" cdkFocusInitial (click)="cancel()"></div>

<h1 mat-dialog-title>
  {{ data.title }}
</h1>

<div class="dashboard-chips" mat-dialog-content>
  <mat-form-field class="dashboard-chips-form">
    <mat-chip-grid #phoneOpts>
      @for (chip of data.chips; track chip) {
        <mat-chip-row [removable]="data.removable" (removed)="remove(chip)">
          {{chip}}
          @if (data.removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-row>
      }
      <input id="email-input"
        placeholder="+ Add phone number"
        type="email"
        [formControl]="phoneCtrl"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputFor]="phoneOpts"
        (matChipInputTokenEnd)="add($event.value)">
    </mat-chip-grid>
  </mat-form-field>

  @if (phoneCtrl?.invalid && (phoneCtrl?.dirty || phoneCtrl?.touched) && phoneCtrl?.errors?.['invalidPhoneNumber']) {
    <mat-error
      class="margin-t-20 margin-b-8">
    Please enter valid phone number</mat-error>
  }
  @if (data.message) {
    <div class="message" [innerHTML]="data.message"></div>
  }
  @if (data.extra_message) {
    <div class="info-message">
      <img [src]="infoIcon" alt="" width="16" height="16">
      <span [innerHTML]="data.extra_message"></span>
    </div>
  }
</div>
<div mat-dialog-actions class="ui-layout" ui-layout-align="end">
  <button mat-button class="dashboard-button" (click)="cancel()">{{ data.cancelText }}</button>
  <button mat-button class="dashboard-button confirm focused"
    (click)="confirm()"
    [disabled]="(!data.chips.length && !phoneCtrl.value.length) || (phoneCtrl?.dirty || phoneCtrl?.touched) && phoneCtrl?.errors?.['invalidPhoneNumber']">{{ data.confirmText }}
  </button>
</div>